import Svg, { Circle, Path } from "react-native-svg";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import React, { useState } from "react";
import { useLocalSearchParams } from "expo-router";
import { useRef } from "react";
import { useWindowDimensions } from "react-native";
import BottomSheetModal from "components/BottomSheetModal";
import VText from "components/VText";

const SizeModal = React.forwardRef(({ setCartData, cartData }, ref) => {
    const _sizeGuideRef = useRef();
    const { height, width } = useWindowDimensions();
    const [productData, setProductData] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const local = useLocalSearchParams();

    const gender = local?.gender ?? "female";

    React.useImperativeHandle(ref, () => ({ show }), []);

    const show = (productData, selectedSize) => {
        setProductData(productData);
        setSelectedSize(selectedSize);
        _sizeGuideRef?.current?.show();
    };

    return (
        <BottomSheetModal
            START_PERC={1}
            MAX_HEIGHT_PERC={1}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
            ref={_sizeGuideRef}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => _sizeGuideRef?.current?.hide()}
            >
                <TouchableOpacity
                    style={{
                        width: wp(815),
                        minHeight: "auto",
                        backgroundColor: "#fff",
                        paddingVertical: spV(25),
                        paddingHorizontal: spH(25),
                        overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <View style={{ borderBottomWidth: 1, borderColor: "#2124274D", paddingBottom: spV(5) }}>
                        <VText style={{ fontSize: fp(14), fontWeight: "600" }} text="SIZE GUIDE" />
                        <TouchableOpacity
                            onPress={() => _sizeGuideRef?.current?.hide()}
                            activeOpacity={0.8}
                            style={{
                                position: "absolute",
                                right: 0,
                                top: -5,
                            }}
                        >
                            <Svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
                                <Path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                                    fill="#212427"
                                />
                            </Svg>
                        </TouchableOpacity>
                    </View>
                    <View
                        style={{
                            paddingVertical: spV(20),
                            flexDirection: "row",
                            justifyContent: "left",
                            borderBottomWidth: 1,
                            borderColor: "#2124274D",
                        }}
                    >
                        <Image
                            source={{ uri: productData?.imageUrls[0] }}
                            style={{ height: hp(88), width: wp(70) }}
                            resizeMode="cover"
                        />
                        <View style={{ marginLeft: spH(20) }}>
                            <VText
                                style={{ fontSize: fp(14), fontWeight: "400", lineHeight: "1.5rem" }}
                                text={productData?.brandName}
                            />
                            <VText
                                style={{ fontSize: fp(14), fontWeight: "350", lineHeight: "1.5rem" }}
                                text={productData?.productName}
                            />
                            <VText
                                style={{ fontSize: fp(12), fontWeight: "400", lineHeight: "1.5rem" }}
                                text={productData?.productColor}
                            />
                            <View style={{ flexDirection: "row", flexWrap: "wrap", marginTop: spV(10) }}>
                                <View
                                    style={{
                                        width: wp(12),
                                        height: hp(12),
                                        backgroundColor: productData?.productColorCode,
                                        borderRadius: 100,
                                    }}
                                />
                                <VText
                                    style={{
                                        color: "#21242799",
                                        fontSize: fp(12),
                                        fontWeight: "350",
                                        marginLeft: spH(10),
                                    }}
                                    text={productData?.productColor}
                                />
                            </View>
                        </View>
                    </View>
                    <View style={{ paddingVertical: spV(20) }}>
                        <VText style={{ fontSize: fp(14), fontWeight: "600" }} text="SIZE CONVERSION" />
                        <VText
                            style={{ fontSize: fp(12), fontWeight: "350" }}
                            text="Use the below conversion chart to find your size"
                        />
                    </View>
                    <View
                        style={{
                            flexDirection: "row",
                            gap: spH(10),
                            overflow: "scroll",
                            scrollSnapType: "x mandatory",
                            borderBottomWidth: 1,
                            borderColor: "#2124274D",
                            paddingBottom: spV(20),
                        }}
                    >
                        {productData?.sizeGuide?.map((item, index) => {
                            return (
                                <View
                                    key={index}
                                    style={{
                                        width: wp(160),
                                        backgroundColor: "white",
                                        borderWidth: 0.5,
                                        borderColor: "#21242799",
                                        paddingBottom: spV(20),
                                        paddingHorizontal: spH(10),
                                        paddingTop: spV(10),
                                    }}
                                >
                                    <View>
                                        <TouchableOpacity
                                            style={{
                                                flexDirection: "row",
                                                alignItems: "center",
                                            }}
                                            onPress={() => {
                                                if (productData?.id) {
                                                    setCartData((prevCartData) => {
                                                        const existingItem = prevCartData.find(
                                                            (cartItem) => cartItem?.productId === productData?.id
                                                        );

                                                        if (existingItem) {
                                                            return prevCartData.map((cartItem) =>
                                                                cartItem.productId === productData?.id
                                                                    ? { ...cartItem, size: item.originalSizeName }
                                                                    : cartItem
                                                            );
                                                        } else {
                                                            return [
                                                                ...prevCartData,
                                                                {
                                                                    productId: productData?.id,
                                                                    size: item?.originalSizeName,
                                                                    quantity: 1,
                                                                },
                                                            ];
                                                        }
                                                    });
                                                }
                                                _sizeGuideRef?.current?.hide();
                                            }}
                                            activeOpacity={0.6}
                                        >
                                            <View
                                                style={{
                                                    height: 16,
                                                    width: 16,
                                                    borderRadius: "100%",
                                                    borderWidth: 1,
                                                    borderColor:
                                                        selectedSize === item.originalSizeName
                                                            ? "#212427"
                                                            : "#2124274D",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    marginRight: spH(10),
                                                }}
                                            >
                                                {selectedSize === item.originalSizeName && (
                                                    <View
                                                        style={{
                                                            height: 10,
                                                            width: 10,
                                                            borderRadius: "100%",
                                                            backgroundColor: "#212427",
                                                        }}
                                                    />
                                                )}
                                            </View>
                                        </TouchableOpacity>
                                    </View>
                                    <View style={{ marginTop: spV(10) }}>
                                        <VText
                                            style={{ fontSize: fp(12), fontWeight: "400" }}
                                            text={item.originalSizeName}
                                        />
                                        <VText
                                            style={{ fontSize: fp(12), fontWeight: "350", display: "block" }}
                                            text={`is equivalent to a ${
                                                gender == "male" && [3].includes(productData?.categoryId)
                                                    ? `${item?.["Alpha"] ? `${item.Alpha}` : `US${item.US}`}`
                                                    : `US${item?.US}`
                                            }`}
                                        />
                                    </View>
                                    <View
                                        style={{
                                            marginTop: spV(10),
                                            marginBottom: spV(10),
                                            width: wp(18),
                                            height: hp(3),
                                            backgroundColor: "#212427",
                                        }}
                                    ></View>

                                    {Object.keys(item)
                                        .filter((key) =>
                                            gender == "male" && [3].includes(productData?.categoryId)
                                                ? key !== "Alpha" && key !== "originalSizeName"
                                                : key !== "US" && key !== "originalSizeName"
                                        )
                                        .map((key) => (
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    marginVertical: spV(3),
                                                }}
                                            >
                                                <VText
                                                    key={key}
                                                    style={{ fontSize: fp(12), fontWeight: "400" }}
                                                    text={`${key}`}
                                                />
                                                <VText
                                                    key={key}
                                                    style={{ fontSize: fp(12), fontWeight: "400" }}
                                                    text={`${item[key]}`}
                                                />
                                            </View>
                                        ))}
                                </View>
                            );
                        })}
                    </View>
                    <View style={{ marginTop: spH(20), marginBottom: spV(10), width: "90%" }}>
                        <VText style={{ fontSize: fp(14), fontWeight: "600" }} text="RETURNS OR EXCHANGES" />
                        <VText
                            style={{ fontSize: fp(12), fontWeight: "350", marginTop: spV(5) }}
                            text="Try your purchase in the comfort of your own home and, if it’s not quite right, let us know and we’ll arrange a collection from your address."
                        />
                    </View>
                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

SizeModal.displayName = "SizeModal";
export default React.memo(SizeModal);
